var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2929_31595",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2929_31595",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADiElEQVR4nO2dzW4TMRDHR5U4teIlqG1UIBwQH09BLyAO9Bx7I3HmGE6lt368AnkmWnGDN4AggdSKVN4Q6G6ySZr12mP7/5N8HW/n14m9dqIhAgAAAAAAAIAYeNK/Q0q/ImFGJMw5CfOTpJlkPYQe/83FqMyNzZEXpN4nYb4ET4BkPsoc6f0OTQy3SOiPwf9QGdX4Q9IclrlzDmRMWog5dCvDlt7U9s1JfpHQxyT0M+odbFPu9A62y1wIc1Lmpl4pyrx0M5FdnObXjK903zx0M0GCqP4jkvrb3JriZKG3O4Z6ZUDGulJ+V3Jnc9kau42rmNbH7YNmgtSntdx9ah9U6ItqhRRPXTxrFoj+85qQCwdB9bgSdG+w4+JZs2BvsFMTMm4ftL6FA4HzByHtgBBmQAgzIIQZEMIMCGEGhDADQpgBIcyAEGZACDOiFHJv8KCTuByeITohQn8gaa5IFgcUClW8JqEvSeijvIVMZcxiXwWRMpPx/4j8KE8h9hr4ZiKmybgk2X9DvrBzLXoGl1fU0QixlN9+rCVEeqqUemXM5lb6rdN5ohISSoryJCNKIb6lKI8yohXiS4ryLCNqIV1LUQFkRC+kKymhZCQhxLWUkDKSEeJKSmgZSQlpK4WDjOSEbCqFi4wkhdxWCicZyQpZVwo3GUkLWSWFo4zkhSw7oQ19cpytkOZK4VUZWQlZLoWPjLyEFIvWjM3f6LsiCyGqUQY/KckLkVjU+QhRS7a2Ia+Ds6wQtcZ7BkcpSQpRt3jp4yYlOSFqgzdwTlKSEqJaHIdwkZKMEOXgbIqDlCSEKIcHhaGlRC9EdXBqG1JK1EJUh0fooaREK8THfYYKICVKIT4vl5RnKdEJCXHTpzxKiUpIyGtX5UlKNELwgx2GFSKL994rY3WlDCnLCqlKCXvtqv5JcSsjSiEW/Cya+dFJSkRZISkjIYQXEMIMCGEGhDADQpgBIcyAEGZACDMghBkQkroQYX5UAqKhy/rsvrtbFaK/k/OWR7Y1HFiPXfOig5ZH9aZg5qR90EyQ5sx9U7BFbfNsSziwHKEfd9M2r6mxJKQ0I4ted40lG1uvWvv6tPycxEJPZQ6ma8bZXGU4bb06A82JJ3yaE5cMt8rA802KMWSI9t0zbOmhwf1k5T+izZHzj6km7OJUfnXGjEiY87luoDkOYXOgP5dbW5sbZws4AAAAAAAAAFCnXANKdR1Ui6p79QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.7711e7f2e9fd4947fcc564d1650f769d.svg";
export { ForwardRef as ReactComponent };